// material-ui
import { Box } from '@mui/material';

// assets
import logoImage from 'assets/images/logo3.webp';

// ==============================|| LOGO ICON IMAGE ||============================== //

export default function LogoIcon() {
  return (
    <Box
      component="img"
      src={logoImage}
      alt="Foire Livre Logo"
      sx={{
        height: '55px',
        width: '55px',
        objectFit: 'contain'
      }}
    />
  );
}
